"use strict";

import Cropper from "cropperjs";
import "cropperjs/src/css/cropper.scss";

import { FilesUploadGateway } from "../../../gateway/FilesUploadGateway";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import "./user-profile-avatar-dialog.scss";
import "./user-profile-avatar-dialog-dark.scss";

class UserProfileAvatarDialogCtrl {
    constructor($mdDialog, locals, LoaderService) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.LoaderService = LoaderService;
        this.copper = {};
        this.result = {};
        this.zoom = 0;
        this.imageData = this.locals.imageData;
    }
    $onInit() {
        this.initCropper();
    }
    onCrop() {
        let croppedCanvas;
        let roundedImage;
        if (!this.croppable) {
            return;
        }
        croppedCanvas = this.cropper.getCroppedCanvas();
        roundedImage = document.createElement("img");
        roundedImage.src = croppedCanvas.toDataURL();
        this.result.innerHTML = "";
        this.result.appendChild(roundedImage);
    }
    initCropper() {
        this.croppable = false;
        setTimeout(() => {
            const element = document.getElementById("CropperArea");
            this.result = document.getElementById("ResultCrop");
            this.cropper = new Cropper(element, {
                viewMode: 3,
                autoCropArea: 1,
                aspectRatio: 1,
                guides: false,
                cropBoxResizable: false,
                dragMode: "move",
                toggleDragModeOnDblclick: false,
                ready: () => {
                    this.croppable = true;
                    this.cropper.zoomTo(0);
                }
            });
        }, 500);
    }
    onZoomImage(zoom = this.zoom) {
        this.cropper.zoomTo(zoom);
    }
    getRoundedCanvas(sourceCanvas) {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let width = sourceCanvas.width;
        let height = sourceCanvas.height;
        canvas.width = width;
        canvas.height = height;
        context.imageSmoothingEnabled = true;
        context.drawImage(sourceCanvas, 0, 0, width, height);
        context.globalCompositeOperation = "destination-in";
        context.beginPath();
        context.arc(
            width / 2,
            height / 2,
            Math.min(width, height) / 2,
            0,
            2 * Math.PI,
            true
        );
        context.fill();
        return canvas;
    }
    onSetZoom(amount) {
        const zoom = Math.abs(this.zoom) + amount;
        this.zoom = zoom;
        this.onZoomImage();
    }
    isZoomDisabled(amount) {
        if (amount === 0 && this.zoom === amount) return true;
        if (amount === 1 && this.zoom > 0.9) return true;
    }
    cancel() {
        this.$mdDialog.cancel();
    }
    _getDataImageUrl() {
        if (!this.croppable) {
            return;
        }
        let croppedCanvas = this.cropper.getCroppedCanvas();
        return croppedCanvas.toDataURL();
    }
    async _pictureUpload(dataImageUrl) {
        const filesUploadGateway = new FilesUploadGateway();
        const response = await filesUploadGateway.image({
            accountingId: new UserDataAdapter().user()?._id,
            bucketName: "nucont-logos",
            base64: dataImageUrl
        });
        return response?.[0] || "";
    }
    async onSave() {
        this.loading = true;
        this.LoaderService.setProgress(true);
        const dataImageurl = this._getDataImageUrl();
        const url = await this._pictureUpload(dataImageurl);
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.$mdDialog.hide(url);
    }
}

angular.module("nucont.shared").controller("UserProfileAvatarDialogCtrl", [
    "$mdDialog",
    "locals",
    "LoaderService",
    UserProfileAvatarDialogCtrl
]);
